import { action } from "@ember/object"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import styles from "./create-modal.module.css"

export default class CreatModalComponent extends Component {
  readonly styles = styles
  @tracked isSmall = false
  @action setSmallWidth() {
    this.isSmall = true
  }
  @action setNormalWidth() {
    this.isSmall = false
  }
}
